import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { ChiamaAPI, Bottone, Trad, Paginatore, BaseComponent, Tipo, BottoneAPI } from '../components/';
import { Layout } from '../layout/Layout';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IQuietanzeListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPagineQuietanze;
    ParamAPIPagine: Dati.CParamAPIPagine;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class QuietanzaLista extends BaseComponent<Glob.IRouteGlobaleProps, IQuietanzeListaState> {

    private ParametriFissi: Dati.TListaParametri = {};

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        this.state = { Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, Parametri: this.ParametriFissi, ParametriUtente: {} };
        this.OnInvio = this.OnInvio.bind(this);
        this.OnRis = this.OnRis.bind(this);
        this.OnErroreLista = this.OnErroreLista.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        this.OnChange = this.OnChange.bind(this);

        var M = Glob.GetMenu();
        M.Main = "Home";
        M.ID_MenuMain = 36;
        M.VariabiliMenu = {};
        this.props.SetMenu(M);
    }

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [7, 8], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("ID_Quietanza", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 1:
                                this.OnOrdinamento("ID_Polizza", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 2:
                                this.OnOrdinamento("TipoQuietanza", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 3:
                                this.OnOrdinamento("Progressivo", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 4:
                                this.OnOrdinamento("TipoQuietanzaStato", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 5:
                                this.OnOrdinamento("DataInizioCopertura", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 6:
                                this.OnOrdinamento("DataFineCopertura", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }

    private OnClickUrl(sender: BottoneAPI, dati: Dati.CRisAPISemplice<string>) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            this.props.history.push(dati.Dato);
        }
    }

    private OnClickIncassata(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            this.setState({ Caricamento: true, Aggiornare: this.state.Aggiornare + 1 });
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        return false;
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnErroreLista(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private calcolaProvvigione(premioJSON: any): number {
        let valorePremio: number = 0;
        let premio = JSON.parse(premioJSON);
        for (let i: number = 0; i < premio.length; i++) {
            for (let j: number = 0; j < premio[i].length; j++) {
                valorePremio += (premio[i][j].ValoreProvvigione * 1);
                //console.warn("VALORE: ", provvigione[i][j].ValoreProvvigione);
            }
        }
        return valorePremio;
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPagineQuietanze, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={9} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.Dati.map((dato, i) =>
                    <tr data-row="0" key={i}>
                        <td data-field="ID_Quietanza" className="TextLeft">{dato.ID_Quietanza}</td>
                        <td data-field="ID_Polizza" className="TextLeft">
                            <BottoneAPI Default={false} URL={"/api/Url/GetURL?template=" + Layout.GetTemplateUrl(Glob.Tipi_DT_Polizza) + "&tipo=" + Glob.Tipi_DT_Polizza + "&chiave=" + dato.ID_Polizza} Metodo="GET" OnClick={(s, d) => this.OnClickUrl(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Lettura} ClasseAttivo="bottoneTesto" ClasseAttesa="bottoneTesto" Testo={dato.Polizza} Icona="" />
                        </td>
                        <td data-field="TipoQuietanza" className="TextLeft">{dato.TipoQuietanza}</td>
                        <td data-field="Progressivo" className="TextLeft">{dato.Progressivo}</td>
                        <td data-field="TipoQuietanzaStato" className="TextLeft">{dato.TipoQuietanzaStato}</td>
                        <td data-field="DataInizioCopertura" className="TextCenter">{Trad.Trad(dato.DataInizioCopertura)}</td>
                        <td data-field="DataFineCopertura" className="TextCenter">{Trad.Trad(dato.DataFineCopertura)}</td>
                        <td data-field="PremioJSON" className="TextCenter">{Trad.TradParam("{1-I}", [this.calcolaProvvigione(dato.PremioJSON)])}</td>
                        <td data-field="Azioni" className="TextCenter">
                            {Glob.AzioneAbilitata("QuietanzaController", Glob.Scrittura) && dato.ID_TipoQuietanzaStato === Glob.Tipi_QS_Emessa &&
                                <BottoneAPI Default={false} URL={"/api/Quietanza/Incassa?ID_Quietanza=" + dato.ID_Quietanza} Metodo="GET" OnClick={(s, d) => this.OnClickIncassata(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Testo={Trad.Trad("Incassa")} Icona="" />
                            }
                        </td>
                    </tr>
                )}
            </tbody >;
        }
    }

    public render() {
        if (!Glob.AzioneAbilitata("QuietanzaController", Glob.Lettura)) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-donate"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Quietanze")}</h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">

                        </div>
                    </ul>
                </div>
            </div>
            <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Quietanza")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input onChange={(e) => this.OnChange(e)} type="text" value={this.state.ParametriUtente["ID_Quietanza"] || ""} name="ParametriUtente[ID_Quietanza]" className="form-control kt-input" />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Polizza")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input onChange={(e) => this.OnChange(e)} type="text" value={this.state.ParametriUtente["ID_Polizza"] || ""} name="ParametriUtente[ID_Polizza]" className="form-control kt-input" />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Stato")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <Tipo IgnoraPermessi Campo="ParametriUtente[ID_TipoQuietanzaStato]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoQuietanzaStato"] || ""} OnAggiorna={this.OnChange} URL="/api/Tipi/ListaTipi?ID_TipoContesto=QuietanzaStato" />
                        </div>
                    </div>
                    <div className="form-group kt-form login-form__group row">
                        <label className="col-lg-1 col-form-label">
                            {Trad.Trad("TipoFile")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo Campo="ParametriUtente[ID_TipoQuietanza]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoQuietanza"] || ""} OnAggiorna={this.OnChange} URL="/api/Tipi/ListaTipi?ID_TipoContesto=Quietanza" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__foot kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                        <div className="row">
                            <div className="col kt-form__actions kt-form__actions--center">
                                <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.state.ParamAPIPagine.Pagina = 1; this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), ParamAPIPagine: this.state.ParamAPIPagine, Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
            <div>
                <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                    <thead>
                        <tr className="sfondoTab">
                            <th data-field="ID_Quietanza" className="TextCenter">{Trad.Trad("Quietanza")}</th>
                            <th data-field="ID_Polizza" className="TextLeft">{Trad.Trad("Polizza")}</th>
                            <th data-field="TipoQuietanza" className="TextLeft">{Trad.Trad("Tipo")}</th>
                            <th data-field="Progressivo" className="TextLeft">{Trad.Trad("Progressivo")}</th>
                            <th data-field="TipoQuietanzaStato" className="TextLeft">{Trad.Trad("Stato")}</th>
                            <th data-field="DataInizioCopertura" className="TextLeft">{Trad.Trad("InizioCopertura")}</th>
                            <th data-field="DataFineCopertura" className="TextCenter">{Trad.Trad("FineCopertura")}</th>
                            <th data-field="PremioJSON" className="TextCenter">{Trad.Trad("Premio")}</th>
                            <th data-field="Azioni" className="TextCenter">{Trad.Trad("Azioni")}</th>
                        </tr>
                    </thead>
                    <ChiamaAPI Aggiornare={this.state.Aggiornare} URL="/api/quietanza/ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreLista} />
                </table>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/QuietanzaLista.tsx